import { useEffect, useState } from "react";

export default function ContestCounter({ count }) {
  const [displayed, setDisplayed] = useState(0);

  useEffect(() => {
    if (count == null) return;
    const target = count;
    const duration = 900;
    const start = performance.now();

    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      // Ease-out cubic
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplayed(Math.round(eased * target));
      if (p < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }, [count]);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: 10 }}>
      {/* Trophy icon */}
      <div style={{
        width: 52,
        height: 52,
        borderRadius: 16,
        background: "rgba(251,191,36,0.1)",
        border: "1px solid rgba(251,191,36,0.2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 24,
        boxShadow: "0 0 20px rgba(251,191,36,0.15)",
      }}>
        🏆
      </div>

      {/* Animated count */}
      <div style={{
        fontSize: 48,
        fontWeight: 800,
        fontFamily: "var(--font-display)",
        background: "linear-gradient(135deg, #fbbf24, #f97316)",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        WebkitTextFillColor: "transparent",
        letterSpacing: "-0.04em",
        lineHeight: 1,
      }}>
        {count != null ? displayed.toLocaleString() : "—"}
      </div>

      <div style={{
        fontSize: 11,
        color: "rgba(148,163,184,0.5)",
        fontFamily: "var(--font-display)",
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        textAlign: "center",
      }}>
        Contests
        <br />
        Attended
      </div>
    </div>
  );
}
